import { faBell, faChevronCircleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { Modal as AntdModal,} from "antd";
import React, { useEffect, useState } from 'react'
import CalendarAPI from './util/CalendarAPI';
import { toIsoString } from './util/appUtils';

export default function ReminderNotification({token}) {
      const [reminderNotify, setReminderNotify] = useState(false);
      const [notificationEvent, setNotificationEvent] = useState(""); 
      const [notificationEventDateTime, setNotificationEventDateTime] = useState(
          new Date()
        ); 
      const [reminderNotifyMsg, setReminderNotifyMsg] = useState("");

      useEffect(()=>{ 
         if (token) {
             try {
                window.catalyst.notification.enableNotification().then((resp) => {
                  window.catalyst.notification.messageHandler = async (msg) => {
                    let allId = msg.split("-");
                    allId = allId.filter((id) => id && id.trim());
                    // let arr=allId[1];
                    setReminderNotifyMsg(allId[0]);
                    setReminderNotify(true);
                    setNotificationEvent(allId[1]);
                    let ids = allId[1].split("_"); //notificationEvent.split('_');
                    let evid = ids[1].replace("EID", "");
                    evid = evid + "@zoho.com";
        
                    CalendarAPI.GetEventDetail(ids[0], evid)
                      .then((result) => {
                        if (result && result.length > 0) {
                          setNotificationEventDateTime(
                            moment(result[0].dateandtime.start).$d
                          );
                        }
                      })
                      .catch((err) => {
                        console.error(err);
                      });
                  };
                });
            } catch (err){
                console.log("Invalid token");
            }
        }
      },[token])
      const handleSnoozeButton = async (ids, minutes) => {
          ids = ids.split("_"); //notificationEvent.split('_');
          let evid = ids[1].replace("EID", "");
          evid = evid + "@zoho.com";
      
          CalendarAPI.GetEventDetail(ids[0], evid)
            .then((result) => {
              result = result[0];
              let start = new Date(moment(result.dateandtime.start).$d);
              start.setMinutes(start.getMinutes() + minutes);
              result.dateandtime.start = toIsoString(start);
              // result.dateandtime.start=
              return CalendarAPI.UpdateEvent(ids[0], evid, {
                dateandtime: result.dateandtime,
                etag: result.etag,
              });
            })
            .then((result) => {
              setReminderNotify(false);
              setReminderNotifyMsg("");
            })
            .catch((err) => {
              console.error(err);
            });
        };
  return (
    <div>
      <>
        <AntdModal
          footer={null}
          mask={false}
          className="popup-notification"
          title={reminderNotifyMsg}
          open={reminderNotify}
          onOk={() => setReminderNotify(false)}
          onCancel={() => setReminderNotify(false)}
        >
          <div className="d-flex mb-3">
            <p>
              <FontAwesomeIcon color="yellow" className="mr-2" icon={faBell} />
            </p>
            <div>
              <span className="font-weight-bold mr-1">Time:</span>
              <span>
                {moment(notificationEventDateTime).format(
                  "ddd, MMM DD, YYYY, hh:mm a"
                )}
              </span>
            </div>
          </div>
          <button
            onClick={() => setReminderNotify(false)}
            className="btn btn-sm btn-outline-primary"
          >
            Cancel
          </button>
          <div className="btn-group">
            <button
              style={{
                borderTopLeftRadius: "45px",
                borderBottomLeftRadius: "45px",
              }}
              onClick={async () => {
                let ids =
                  "d8140b3f7b9a49d39872dc98ba68b1af_EID0f0d9e3f0dbb4ae8b9ef71190f266c0e";
                handleSnoozeButton(notificationEvent, 5);
              }}
              type="button"
              className="btn btn-sm btn-primary"
            >
              Snooze For 5 Min
            </button>
            <button
              style={{
                borderTopRightRadius: "45px",
                borderBottomRightRadius: "45px",
              }}
              type="button"
              className="btn btn-sm btn-primary  dropdown-toggle-split"
              data-toggle="dropdown"
            >
              <span className="caret">
                <FontAwesomeIcon icon={faChevronCircleDown} />
              </span>
            </button>
            <div className="dropdown-menu">
              <a
                onClick={() => handleSnoozeButton(notificationEvent, 10)}
                className="dropdown-item"
                href="#"
              >
                For 10 Min
              </a>
              <a
                onClick={() => handleSnoozeButton(notificationEvent, 15)}
                className="dropdown-item"
                href="#"
              >
                For 15 Min
              </a>
              <a
                onClick={() => handleSnoozeButton(notificationEvent, 20)}
                className="dropdown-item"
                href="#"
              >
                For 20 Min
              </a>
            </div>
          </div>
          {/* <button onClick={()=>setReminderNotify(false)} className="btn btn-sm btn-outline-secondary">Snooze</button> */}
        </AntdModal>
      </>
    </div>
  )
}
